import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect, useRef } from "react";
import { addTableCaptions, htmlWithoutSpaces, PastingData, transformHeadings } from "../utils/editorstateHelper";
import { $generateNodesFromDOM } from "@lexical/html";
import { $isHeadingNode } from "@lexical/rich-text";
import { $createParagraphNode, $getRoot, $insertNodes, $isElementNode, $isRangeSelection, CLEAR_HISTORY_COMMAND, LexicalEditor, LexicalNode, RangeSelection } from "lexical";
import { $createLayoutContainerNode, $isLayoutContainerNode, LayoutContainerNode } from "../nodes/LayoutContainerNode";
import { $createLayoutItemNode, $isLayoutItemNode, getSelectedPage, LayoutItemNode } from "../nodes/LayoutItemNode";

export function InitialContentPlugin({ showPagination, enableCaptions, setEditorEditable, htmlString, isEditable, setIsexistingIdPresent, editId, styleConfig }: any) {
  const [editor] = useLexicalComposerContext();
  const preservedIdMap = useRef({});

  useEffect(() => {
    editor.update(() => {
      const parser = new DOMParser();
      const htmlNoSpace = htmlWithoutSpaces(htmlString);
      const addCaptionHtml = addTableCaptions(htmlNoSpace,styleConfig)
      let pureHeadingHtml = transformHeadings(addCaptionHtml);
      const dom = parser.parseFromString(enableCaptions === true ? pureHeadingHtml : htmlNoSpace, 'text/html');
      dom.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const existingId = heading.getAttribute('id');
        if (existingId) {
          heading.setAttribute('data-preserved-id', existingId);
        }
      });
      const nodes = $generateNodesFromDOM(editor, dom);
      nodes.forEach((node) => {
        if ($isHeadingNode(node)) {
          const element = editor.getElementByKey(node.getKey());
          if (element) {
            const preservedId = element.getAttribute('data-preserved-id');
            // if (preservedId) {
            //   const customHeading = CustomHeadingNode.create(node.getHeadingLevel(), preservedId);
            //   node.replace(customHeading);
            // }
          }
        }
      });

      const root = $getRoot();
      root.clear();
      const hasLayoutStructure = nodes.some(
        (node) =>
          node.getType() === 'layout-container'
      );


      function insertNodesWithPaginationToLayoutItem(
        nodes: LexicalNode[],
        editor: LexicalEditor,
        targetPage: LayoutItemNode,
        styleConfig?: {
          tableStyles: {
            headerColor: string;
            rowColor: string;
          };
        }
      ) {
        editor.update(() => {
          nodes = nodes.filter(node => !$isLayoutItemNode(node));
          if (nodes.length === 0) return;

          const nodesPerPage = 30;
          let currentPage = targetPage;
          let nodeCount = 0;

          let insertionPoint: LexicalNode | null = currentPage.getChildren().slice(-1)[0] || null;

          nodes.forEach((node, index) => {
            if (nodeCount >= nodesPerPage && index < nodes.length - 1) {
              const newPage = $createLayoutItemNode('custom-div');
              newPage.setHeaderText(currentPage.getHeaderText());
              newPage.setFooterText(currentPage.getFooterText());
              currentPage.insertAfter(newPage);
              currentPage = newPage;
              nodeCount = 0;
              insertionPoint = null;
            }

            if (insertionPoint && $isElementNode(insertionPoint) && insertionPoint.getParent() === currentPage) {
              insertionPoint.insertAfter(node);
              insertionPoint = node;
            } else {
              currentPage.append(node);
              insertionPoint = node;
            }

            nodeCount++;
          });
        });
      }

      function insertNodesWithPaginationControl(nodes: any[], showPagination: boolean) {
        const root = $getRoot();
        const hasContainer = nodes.some((n) => $isLayoutContainerNode(n));
        const hasItem = nodes.some((n) => $isLayoutItemNode(n));

        if (!showPagination) {
          nodes.forEach((node) => {
            if ($isLayoutContainerNode(node)) {
              const children = node.getAllChildren();
              children.forEach((child) => root.append(child));
            } else {
              root.append(node);
            }
          });
          editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
          return;
        }

        if (showPagination === true) {


          root.clear();

          let containerNode: LayoutContainerNode;
          let itemNode: LayoutItemNode;


          if (hasContainer && hasItem) {
            nodes.forEach((node) => root.append(node));
            editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
            return;
          }

          if (!hasContainer && hasItem) {
            root.clear();
            let header: any;
            let footer: any;
            let nodeArr: any = [];

            nodes.forEach((node) => {
              if ($isLayoutItemNode(node)) {
                header = node.getHeaderText();
                footer = node.getFooterText();
                const children = node.getChildren();
                children.forEach((child) => nodeArr.push(child));
              } else {
                nodeArr.push(node);
              }
            });
            const container = $createLayoutContainerNode('1fr');
            const item = $createLayoutItemNode('custom-div');
            const para = $createParagraphNode()
            item.append(para)
            item.setHeaderText(header);
            item.setFooterText(footer)
            container.append(item);
            root.clear();
            root.append(container)
            insertNodesWithPaginationToLayoutItem(nodeArr, editor, item, styleConfig)
            editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
            return;

          }

          if (!hasContainer && !hasItem) {

            containerNode = $createLayoutContainerNode('1fr')
            itemNode = $createLayoutItemNode('custom-div')
            containerNode.append(itemNode);
            root.append(containerNode)
            insertNodesWithPaginationToLayoutItem(nodes, editor, itemNode, styleConfig)
            editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
            return;
          }

          if (hasContainer && !hasItem) {
            const container = nodes.find((n) => $isLayoutContainerNode(n));
            if (container) {
              root.clear();
              root.append(container);
              editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined);
            }
          }
        }
      }


      insertNodesWithPaginationControl(nodes, showPagination)




      editor.setEditable(false)
      setTimeout(() => {
        editor.setEditable(isEditable)
        setEditorEditable(true)
      }, 5000)
    });
  }, [editor, htmlString, showPagination]);


  // useEffect(() => {
  //   const container = document.querySelector(`.editor-autosave-${editId}`) as HTMLElement | null;
    
  //   if (!container || showPagination) return;

  //   const handlePaste: EventListener = (event) => {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     const clipboardEvent = event as ClipboardEvent;
  //     const data = clipboardEvent.clipboardData || (window as any).clipboardData;
  //     const pastedHTML = data?.getData("text/html");
  //     PastingData( editor, enableCaptions, styleConfig,showPagination);
  //   };

  //   container.addEventListener('paste', handlePaste);
  //   return () => {
  //     container.removeEventListener('paste', handlePaste);
  //   };
  // }, [editId]);



  return null;
}